const LANGUAGE_KEY = 'rentpilot_language';

export const saveLanguage = async (language: string) => {
  localStorage.setItem(LANGUAGE_KEY, language);
};

export const getLanguage = async (): Promise<string | null> => {
  return localStorage.getItem(LANGUAGE_KEY);
};
